import React, { Component } from "react";
import { connect } from "react-redux";
import { change_Lang } from "../../actions/Helper_action";
import Time from "react-time-format";
import { Get_List_Scurity } from "../../actions/Invoice_action";
class PrintListScurety extends Component {
  componentDidMount() {
    this.props.Get_List_Scurity();
  }
  render() {
    const { change_Lang, list_scurety, primary_logo, footer_logo_bill } =
      this.props;
    const datas = list_scurety.reverse().map((user, i) => {
      return (
        <tr
          key={i}
          className="f4"
          style={{
            borderBottom: "2px solid black",
            borderTop: "2px solid black",
            borderRight: "2px solid black",
            borderLeft: "2px solid black",
          }}
        >
          <td
            style={{
              borderBottom: "2px solid black",
              borderTop: "2px solid black",
              borderRight: "2px solid black",
              borderLeft: "2px solid black",
              fontSize: "1em",
              color: "black",

              textAlign: "center",
            }}
            className="fk"
          >
            {i + 1}
          </td>
          <td
            style={{
              borderBottom: "2px solid black",
              borderTop: "2px solid black",
              borderRight: "2px solid black",
              borderLeft: "2px solid black",
              fontSize: "1em",
              color: "black",

              textAlign: "center",
            }}
            className="fk"
          >
            {user.branchId && user.branchId.name}
          </td>
          <td
            style={{
              borderBottom: "2px solid black",
              borderTop: "2px solid black",
              borderRight: "2px solid black",
              borderLeft: "2px solid black",
              fontSize: "1em",
              color: "black",

              textAlign: "center",
            }}
            className="fk"
          >
            {user.scuertyName}
          </td>
          <td
            style={{
              borderBottom: "2px solid black",
              borderTop: "2px solid black",
              borderRight: "2px solid black",
              borderLeft: "2px solid black",
              fontSize: "1em",
              color: "black",

              textAlign: "center",
            }}
            className="fk"
          >
            {user.ownername}
          </td>
          <td
            style={{
              borderBottom: "2px solid black",
              borderTop: "2px solid black",
              borderRight: "2px solid black",
              borderLeft: "2px solid black",
              fontSize: "1em",
              color: "black",
              textAlign: "center",
            }}
            className="fk"
          >
            {user.tenantname}
          </td>
          <td
            style={{
              borderBottom: "2px solid black",
              borderTop: "2px solid black",
              borderRight: "2px solid black",
              borderLeft: "2px solid black",
              fontSize: "1em",
              color: "black",

              textAlign: "center",
            }}
            className="fk"
          >
            <Time
              value={user.createdAt}
              format="YYYY-MM-DD"
              style={{ color: "black" }}
            />
          </td>
        </tr>
      );
    });
    return (
      <>
        <table className="table">
          <thead
            id="taed"
            style={{
              borderBottom: "2px solid black",
              borderTop: "2px solid black",
              borderRight: "2px solid black",
              borderLeft: "2px solid black",
              color: "#4064d7",
            }}
            className="fk"
          >
            <tr>
              <td
                style={{
                  textAlign: "center",
                  border: "none",
                }}
                colSpan={6}
              >
                <div class="row">
                  <div class="col-md-12  ">
                    <img
                      src={primary_logo}
                      alt="logo"
                      className="img-fluid img-responsive"
                      style={{
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: "center",
                  border: "none",
                }}
                className="my-5"
                colSpan={6}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    position: "fixed",
                    top: 130,
                    left: 0,
                    right: 0,
                    fontSize: "20px",
                  }}
                >
                  ({change_Lang("Security Bill List")})
                </span>
              </td>
            </tr>
            <tr
              style={{
                borderBottom: "2px solid black",
                borderTop: "2px solid black",
                borderRight: "2px solid black",
                borderLeft: "2px solid black",
              }}
            >
              <th
                style={{
                  borderBottom: "2px solid black",
                  borderTop: "2px solid black",
                  borderRight: "2px solid black",
                  borderLeft: "2px solid black",
                  textAlign: "center",
                }}
                scope="col"
              >
                {change_Lang("Number")}
              </th>
              <th
                style={{
                  borderBottom: "2px solid black",
                  borderTop: "2px solid black",
                  borderRight: "2px solid black",
                  borderLeft: "2px solid black",
                  textAlign: "center",
                }}
                scope="col"
              >
                {change_Lang("Name of Branch")}
              </th>
              <th
                style={{
                  borderBottom: "2px solid black",
                  borderTop: "2px solid black",
                  borderRight: "2px solid black",
                  borderLeft: "2px solid black",
                  textAlign: "center",
                }}
                scope="col"
              >
                {change_Lang("to")}
              </th>
              <th
                style={{
                  borderBottom: "2px solid black",
                  borderTop: "2px solid black",
                  borderRight: "2px solid black",
                  borderLeft: "2px solid black",
                  textAlign: "center",
                }}
                scope="col"
              >
                {change_Lang("Owner Name")}
              </th>
              <th
                style={{
                  borderBottom: "2px solid black",
                  borderTop: "2px solid black",
                  borderRight: "2px solid black",
                  borderLeft: "2px solid black",
                  textAlign: "center",
                }}
                scope="col"
              >
                {change_Lang("The name of the tenant")}
              </th>
              <th
                style={{
                  borderBottom: "2px solid black",
                  borderTop: "2px solid black",
                  borderRight: "2px solid black",
                  borderLeft: "2px solid black",
                  textAlign: "center",
                }}
                scope="col"
              >
                {change_Lang("date")}
              </th>
            </tr>
          </thead>
          <tbody
            style={{
              borderBottom: "2px solid black",
              borderTop: "2px solid black",
              borderRight: "2px solid black",
              borderLeft: "2px solid black",
            }}
          >
            {datas}
          </tbody>
          <tfoot
            style={{
              borderBottom: "2px solid black",
              borderTop: "2px solid black",
              borderRight: "2px solid black",
              borderLeft: "2px solid black",
            }}
          >
            <tr>
              <td
                style={{
                  borderBottom: "2px solid black",
                  borderTop: "2px solid black",
                  borderRight: "2px solid black",
                  borderLeft: "2px solid black",
                  textAlign: "center",
                }}
                colSpan={6}
              >
                <div
                  className="row"
                  style={{
                    width: "100%",
                  }}
                >
                  <div className="col-12">
                    <img src={footer_logo_bill} alt="logo" width="100%" />
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    list_scurety: state.InvoiceReducer.list_scurety,
    primary_logo: state.HelperReducer.primary_logo,
    footer_logo_bill: state.HelperReducer.footer_logo_bill,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    Get_List_Scurity: () => dispatch(Get_List_Scurity()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintListScurety);
